import { createFileRoute } from '@tanstack/react-router'
import { companyKeys } from '@/hooks/useCompanies'
import { companiesAPI } from '@/lib/api/companies'
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_authenticated/companies/$companyId')({
  loader: ({ context: { queryClient }, params: { companyId } }) => {
    return queryClient.ensureQueryData({
      queryKey: companyKeys.detail(companyId),
      queryFn: () => companiesAPI.get(companyId),
      staleTime: 10 * 60 * 1000,
    })
  },
  component: CompanyDetail,
})

function CompanyDetail() {
  const { t } = useTranslation();
  const { companyId } = Route.useParams()

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold">{t('$companyId:companyDetail')}</h1>
      <p className="text-muted-foreground">Company ID: {companyId}</p>
    </div>
  )
}
